/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import CloseAction from './CloseAction/index'
import Input from 'DesignSystem/Input/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Documents/Navigation/Actions/CreateDirectory/Content",
  onChange,
  onSubmit
  
}) {
let directoryNameValueData = fromData.useDataValue({ viewPath,
context: 'directory_name',
})
let directoryNameChangeData = fromData.useDataChange({ viewPath,
context: 'directory_name',
})
let directoryNameSubmitData = fromData.useDataSubmit({ viewPath,
context: 'directory_name',
})
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Input
  viewPath={`${viewPath}/Input`}
 data="directory_name"
 value={directoryNameValueData}
 onChange={directoryNameChangeData}
 placeholder="Directory name"
 width="100%"
 marginTop={20}
 marginBottom={20}
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 text="Create folder"
 data="directory_name"
 onClick={directoryNameSubmitData}
/>
</div>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}